import React from 'react';

type Props = {
  size: number;
};

export const GridIcon = ({ size = 32 }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 32 32"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="currentColor"
        d="M15 17v10H5V17h10zm12 0v10H17V17h10zM15 5v10H5V5h10zm12 0v10H17V5h10z"
      />
    </g>
  </svg>
);
